export function mainCatgeory(post) {
  return post?.categories?.nodes[0]
}
